"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Features = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Features.css"));
var _ValueChange = require("./ValueChange");
var _uiKit = require("@cian/ui-kit");
var _FullCreditTooltip = require("../FullCreditPrice/FullCreditTooltip");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Features = props => {
  const {
    features,
    fullCreditPriceTooltip,
    size,
    onCreditFullPriceClick,
    isBankMortgage
  } = props;
  if (!features || features.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['features'], size === 'S' && style['features--small'])
  }, features.map((_ref, idx) => {
    let {
      name,
      value,
      valueChange,
      type
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: style['feature']
    }, /*#__PURE__*/React.createElement("div", {
      className: style['feature-name']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
      color: "text-secondary-default"
    }, name), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      desktop: true,
      tablet: true
    }, type === 'fullCreditPrice' && fullCreditPriceTooltip && /*#__PURE__*/React.createElement(_FullCreditTooltip.FullCreditPriceTooltip, {
      tooltip: fullCreditPriceTooltip,
      trackClickHandler: onCreditFullPriceClick
    }))), !valueChange && /*#__PURE__*/React.createElement("div", {
      className: style['feature-name']
    }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
      color: type === 'fullCreditPrice' ? 'text-secondary-default' : 'text-primary-default'
    }, value), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, type === 'fullCreditPrice' && fullCreditPriceTooltip && /*#__PURE__*/React.createElement(_FullCreditTooltip.FullCreditPriceTooltip, {
      tooltip: fullCreditPriceTooltip,
      trackClickHandler: onCreditFullPriceClick
    }))), valueChange && /*#__PURE__*/React.createElement(_ValueChange.ValueChange, {
      valueChange: valueChange,
      value: value,
      isBankMortgage: isBankMortgage
    }));
  }));
};
exports.Features = Features;